<template>
  <BaseDataIterator :service="fetchData" disable-search>
    <template #custom-actions="{ queryContext }">
      <UploadAction @upload-completed="queryContext.actions.execute" />
    </template>
    <template #default="dataIteratorProps">
      <ul v-if="dataIteratorProps.data.length" class="grid grid-cols-6 gap-4 p-4">
        <li v-for="mediaItem in dataIteratorProps.data" :key="mediaItem.id">
          <MediaListItem :media-item="mediaItem" @deleted="dataIteratorProps.fetchList" />
        </li>
      </ul>
      <div v-else class="text-center p-12">
        <h3 class="mt-2 text-sm font-medium text-gray-900">No files</h3>
        <p class="mt-1 text-sm text-gray-500">Get started by uploading some files.</p>
      </div>
    </template>
  </BaseDataIterator>
</template>

<script>
import { mediaLibraryMediaClient } from '@/api/clients/admin';
import UploadAction from './UploadAction.vue';
import MediaListItem from './MediaListItem.vue';

export default {
  components: {
    UploadAction,
    MediaListItem,
  },
  methods: {
    fetchData() {
      return mediaLibraryMediaClient.list();
    },
  },
};
</script>
